import { render } from "./HeroiconsOutlinePuzzle.vue?vue&type=template&id=3cf9bdab"
const script = {}

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePuzzle.vue"]])

export default __exports__